export default {
  data: function data() {
    return {};
  },
  methods: {},
  created: function created() {}
};